import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {

    preview(event) {

        event.preventDefault()

        let imageUrl = this.element.dataset.imageUrl
        let imageTitle = this.element.dataset.imageTitle || "Preview"

        let remoteModal =
            document.getElementById("remote_modal")

        remoteModal.innerHTML = `
            <div class="modal fade"
                 tabindex="-1">

                <div class="modal-dialog modal-xl modal-dialog-centered">

                    <div class="modal-content">

                        <div class="modal-header">

                            <h5 class="modal-title">
                                ${imageTitle}
                            </h5>

                            <button type="button"
                                    class="btn-close"
                                    data-bs-dismiss="modal"></button>

                        </div>

                        <div class="modal-body text-center"
                             id="remote_modal_body">

                            <img src="${imageUrl}"
                                 class="img-fluid rounded shadow"
                                 style="max-height:80vh;">

                        </div>

                    </div>

                </div>
            </div>
        `

        let modalElement =
            remoteModal.querySelector(".modal")

        let modal =
            Modal.getOrCreateInstance(modalElement)

        modal.show()

        modalElement.addEventListener(
            "hidden.bs.modal",
            () => {
                remoteModal.innerHTML = ""
            }
        )
    }
}